import React from 'react';
import { PARAGRAPH_TYPES } from './componentList';
export const getParagraph = (node, isPolicy?: boolean) => {
    if (node.type in PARAGRAPH_TYPES) {
        const helper = PARAGRAPH_TYPES[node.type];
        if (helper.disabled) {
            return <p key={node.type}>Disabled component {node.type}</p>;
        }
        const ParagraphComponent = helper.component;
        if (helper.dataTransformer) {
            return (
                <ParagraphComponent
                    key={node.id ? node.id : Math.random()}
                    inputs={helper.dataTransformer(node, isPolicy)}
                />
            );
        } else {
            return (
                <ParagraphComponent
                    key={node.id ? node.id : Math.random()}
                    node={node}
                />
            );
        }
    }
    return <p key={node.type}>Unknown type {node.type}</p>;
};
